import { useState } from "react";

const materials = [
  {
    id: 1,
    symbol: "AgCdO",
    name: "Silver Cadmium Oxide",
    features: [
      "Excellent arc erosion resistance",
      "Low contact resistance",
      "Ideal for heavy switching applications",
    ],
    img: "/Images/silver-cadmium-oxide.png",
    accent: "#e8a020",
  },
  {
    id: 2,
    symbol: <>AgSnO<sub>2</sub></>,
    symbolPlain: "AgSnO₂",
    name: "Silver Tin Oxide",
    features: [
      "Environment-friendly contact material",
      "High welding resistance",
      "Suitable for modern electrical devices",
    ],
    img: "Images/silver-tin-oxide.png",
    accent: "#3a9fd8",
  },
  {
    id: 3,
    symbol: "AgNi",
    name: "Silver Nickel",
    features: [
      "High mechanical strength",
      "Good electrical conductivity",
      <>Ideal for <strong>relays</strong> and low current switching</>,
    ],
    img: "/Images/silver-nickel.png",
    accent: "#d44040",
  },
  {
    id: 4,
    symbol: "Pure Silver",
    name: "Ag",
    isPureSilver: true,
    features: [
      "Highest electrical conductivity with low contact resistance",
      "Silver contact surface bonded to a copper base",
      "Cost-optimized solution commonly used in modular switches",
    ],
    img: "/Images/pure-silver.png",
    accent: "#c0c0c0",
  },
];

export default function ContactMaterials() {
  // eslint-disable-next-line no-unused-vars
  const [hovered, setHovered] = useState(null);

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Barlow:wght@400;500;600;700;800&family=Barlow+Condensed:wght@600;700;800&display=swap');

        * { box-sizing: border-box; margin: 0; padding: 0; }

        .cm-section {
          background: #f0f4f8;
          padding: 26px 14px 40px;
          font-family: 'Barlow', sans-serif;
          min-height: 60vh;
          display: flex;
          flex-direction: column;
          align-items: center;
        }

        .cm-heading {
          font-family: 'Barlow Condensed', sans-serif;
          font-size: 28px;
          font-weight: 80;
          color: #1a2540;
          letter-spacing: 0.5px;
          margin-bottom: 28px;
          text-align: center;
          text-transform: uppercase;
        }

        .cm-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          border: 2.5px solid  ;
          border-radius: 6px;
          overflow: hidden;
          max-width: 1500px;
          width: 100%;
          box-shadow: 0 8px 32px rgba(20,35,80,0.18);
        }

        .cm-card {
          background: #1a2a4a;
          display: flex;
          flex-direction: column;
          border-right: 2px solid #2a3d6a;
          position: relative;
          overflow: hidden;
          transition: transform 0.22s cubic-bezier(.4,0,.2,1), box-shadow 0.22s;
          cursor: default;
        }

        .cm-card:last-child {
          border-right: none;
        }

        .cm-card:hover {
          z-index: 2;
          transform: scale(1.025);
          box-shadow: 0 12px 40px rgba(0,0,0,0.38);
        }

        .cm-card-top {
          padding: 18px 16px 14px;
          position: relative;
          z-index: 1;
        }

        .cm-symbol {
          font-family: 'Barlow Condensed', sans-serif;
          font-size: 25px;
          font-weight: 800;
          color: #ffffff;
          line-height: 1.1;
          letter-spacing: 0.3px;
        }

        .cm-symbol sub {
          font-size: 14px;
          vertical-align: sub;
        }

        .cm-name {
          font-size: 13px;
          font-weight: 500;
          color: #a8bcd8;
          margin-top: 2px;
          line-height: 1.3;
        }

        .cm-divider {
          height: 2px;
          background: linear-gradient(90deg, rgba(255,255,255,0.18) 0%, rgba(255,255,255,0.04) 100%);
          margin: 0 16px;
        }

        .cm-img-wrap {
          position: relative;
          height: 175px;
          overflow: hidden;
          flex-shrink: 0;
        }

        .cm-img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          object-position: center;
          opacity: 0.72;
          transition: opacity 0.3s, transform 0.4s;
          display: block;
        }

        .cm-card:hover .cm-img {
          opacity: 0.88;
          transform: scale(1.06);
        }

        .cm-img-overlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(180deg, rgba(20,36,74,0.15) 0%, rgba(20,36,74,0.62) 100%);
        }

        .cm-features {
          padding: 14px 16px 20px;
          flex: 1;
          z-index: 1;
          position: relative;
        }

        .cm-feature {
          display: flex;
          align-items: flex-start;
          gap: 7px;
          font-size: 12.5px;
          color: #d8e4f4;
          line-height: 1.45;
          margin-bottom: 7px;
          font-weight: 400;
        }

        .cm-feature:last-child {
          margin-bottom: 0;
        }

        .cm-bullet {
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background: #fff;
          flex-shrink: 0;
          margin-top: 5px;
        }

        .cm-feature strong {
          font-weight: 600;
          color: #fff;
        }

        /* Pure Silver last card slight gold tint on bullet */
        .cm-card:last-child .cm-bullet {
          background: #d0d8e8;
        }

        @media (max-width:1500px) {
          .cm-grid {
            grid-template-columns: repeat(2, 1fr);
          }
          .cm-card {
            border-bottom: 3px solid #F8A024;
          }
          .cm-card:nth-child(2), .cm-card:nth-child(4) {
            border-right: none;
          }
        }

        @media (max-width: 500px) {
          .cm-grid {
            grid-template-columns: 1fr;
          }
          .cm-card {
            border-right: none;
          }
        }
      `}</style>
 <div className="cm-grid">
          {materials.map((mat) => (
            <div
              className="cm-card"
              key={mat.id}
              onMouseEnter={() => setHovered(mat.id)}
              onMouseLeave={() => setHovered(null)}
            >
              {/* Header */}
              <div className="cm-card-top">
                <div className="cm-symbol">
                  {mat.isPureSilver ? (
                    <>{mat.symbol} <span style={{ fontWeight: 600, fontSize: 17 }}>({mat.name})</span></>
                  ) : (
                    <>
                      {mat.symbol}{" "}
                      <span style={{ fontWeight: 500, fontSize: 15, color: "#c8d8ee" }}>
                        ({mat.name})
                      </span>
                    </>
                  )}
                </div>
              </div>

              <div className="cm-divider" />

              {/* Features */}
              <div className="cm-features">
                {mat.features.map((feat, i) => (
                  <div className="cm-feature" key={i}>
                    <span className="cm-bullet" />
                    <span>{feat}</span>
                  </div>
                ))}
              </div>

              {/* Image */}
              <div className="cm-img-wrap">
                <img src={mat.img} alt={mat.symbolPlain || mat.symbol} className="cm-img" />
                <div className="cm-img-overlay" />
              </div>
            </div>
          ))}
        </div>
    </>
  );
}
